import { useEffect } from 'react'
import { initMetaPixel } from '../utils/metaPixel'

/**
 * Inyecta el Meta Pixel y registra el PageView una sola vez, después del
 * primer render, para que el script nunca bloquee la pintura inicial.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()
  }, [])
}
